import { http } from '../../../../common/http/client';
import type { Condition } from './condition';

export class ConditionClient {
  updateNote(
    kyccId: number,
    conditionId: number,
    note: string,
  ): Promise<Condition> {
    return http.put<Condition>(
      `/api/v1/my/company/kyccs/${kyccId}/conditions/${conditionId}.json`,
      { json: { condition: { note: note } } },
    );
  }
}
